import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';
import { NotificationsService } from '../services/notifications.service';

let sessionAlertOpen = false;
let handling401 = false;

const publicMatchers = [
  /\/auth\/login\b/i,
];

export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationsService);
  const router = inject(Router);
  const ngZone = inject(NgZone);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const url = request.url || '';
      const isPublic = publicMatchers.some((re) => re.test(url));
      const sessionExpiredCodes = [401, 403, 419, 440, 498];

      if (error.status === 404) return throwError(() => error);

      if (sessionExpiredCodes.includes(error.status)) {
        if (isPublic || router.url.startsWith('/auth/login')) {
          return throwError(() => error);
        }

        if (handling401) return throwError(() => error);
        handling401 = true;

        if (!sessionAlertOpen) {
          sessionAlertOpen = true;
          Swal.close();
          Swal.fire({
            title: 'Session expired',
            text: 'Your session has expired. You will be redirected to the login page.',
            icon: 'warning',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then(() => {
            ngZone.run(() => authService.logout());
            setTimeout(() => { sessionAlertOpen = false; handling401 = false; }, 1200);
          });
        } else {
          ngZone.run(() => authService.logout());
          setTimeout(() => (handling401 = false), 1200);
        }

        return throwError(() => error);
      }

      const msg = error.error?.message || error.statusText || 'Unexpected error';
      notificationService.error(msg);
      return throwError(() => error);
    })
  );
};
